import * as React from "react";

function EUElectric(props) {
  return (
    <svg width="1em" height="1em" viewBox="0 0 28 28" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path d="M14 0.5C21.4558 0.5 27.5 6.54416 27.5 14C27.5 21.4558 21.4558 27.5 14 27.5C6.54416 27.5 0.5 21.4558 0.5 14C0.5 6.54416 6.54416 0.5 14 0.5Z" fill="#B7E9B4" stroke="#58C150"/>
        <path d="M8.9517 23.9167L12.8117 15.7933H6.66511L18.5432 3.24121L14.9886 11.4395H21.1351L8.9517 23.9167Z" fill="#212B36"/>
    </svg>
  );
}

export default EUElectric;
